module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-costume-men-94d9f86145a897c7d9928d9694dda246.jpg";